var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IsDate, IsEnum, IsNotEmpty, IsObject, IsOptional, IsString } from "class-validator";
import { Type } from "class-transformer";
import { UserType } from "healthex-common/user.dtos";
import { ConsentType } from "./consent.dtos";
export var EventCategory;
(function (EventCategory) {
    EventCategory["PATIENT_DIRECTED_DATA_EXCHANGE"] = "PATIENT_DIRECTED_DATA_EXCHANGE";
    EventCategory["DATA_AUTHORIZATION"] = "DATA_AUTHORIZATION";
    EventCategory["PREREAD_FLOW"] = "PREREAD_FLOW";
    EventCategory["CONSENT"] = "CONSENT";
    EventCategory["VIDEO"] = "VIDEO";
    EventCategory["SCREEN"] = "SCREEN";
    EventCategory["CLEAR"] = "CLEAR";
    EventCategory["SOCIAL_LOGIN"] = "SOCIAL_LOGIN";
    EventCategory["PATIENT"] = "PATIENT";
    EventCategory["ERROR"] = "ERROR";
})(EventCategory || (EventCategory = {}));
export var EnrollmentDecision;
(function (EnrollmentDecision) {
    EnrollmentDecision["CONSENTED"] = "CONSENTED";
    EnrollmentDecision["DECLINED"] = "DECLINED";
    EnrollmentDecision["INTERESTED"] = "INTERESTED";
})(EnrollmentDecision || (EnrollmentDecision = {}));
export var PatientDirectedDataAccessDecision;
(function (PatientDirectedDataAccessDecision) {
    PatientDirectedDataAccessDecision["CONSENTED"] = "CONSENTED";
    PatientDirectedDataAccessDecision["DECLINED"] = "DECLINED";
    PatientDirectedDataAccessDecision["INTERESTED"] = "INTERESTED";
})(PatientDirectedDataAccessDecision || (PatientDirectedDataAccessDecision = {}));
export var EnrollmentFlowType;
(function (EnrollmentFlowType) {
    EnrollmentFlowType["SELF_SERVE"] = "SELF_SERVE";
    EnrollmentFlowType["GUIDED"] = "GUIDED";
})(EnrollmentFlowType || (EnrollmentFlowType = {}));
export var ClearAnalyticsEvent;
(function (ClearAnalyticsEvent) {
    ClearAnalyticsEvent["LOGIN_ATTEMPTED"] = "LOGIN_ATTEMPTED";
    ClearAnalyticsEvent["SUCCESS"] = "SUCCESS";
})(ClearAnalyticsEvent || (ClearAnalyticsEvent = {}));
export var LoginAnalyticsEvent;
(function (LoginAnalyticsEvent) {
    LoginAnalyticsEvent["LOGIN_ATTEMPTED"] = "LoginAttempted";
    LoginAnalyticsEvent["LOGIN_COMPLETED"] = "LoginCompleted";
    LoginAnalyticsEvent["LOGIN_SUCCESS"] = "LoginSuccess";
    LoginAnalyticsEvent["LOGIN_ERROR"] = "LoginError";
})(LoginAnalyticsEvent || (LoginAnalyticsEvent = {}));
export const AuthenticationAnalyticsEvent = {
    ACCOUNT_LINKING_ATTEMPTED: "AccountLinkingAttempted",
    ACCOUNT_LINKING_SUCCESSFUL: "AccountLinkingSuccessful",
};
export var PatientAnalyticsEvent;
(function (PatientAnalyticsEvent) {
    PatientAnalyticsEvent["EMAIL_COLLECTED"] = "EmailCollected";
})(PatientAnalyticsEvent || (PatientAnalyticsEvent = {}));
export var ErrorEvent;
(function (ErrorEvent) {
    ErrorEvent["UI_STACK_TRACE"] = "UI_STACK_TRACE";
})(ErrorEvent || (ErrorEvent = {}));
export class BaseEventMetadata {
}
__decorate([
    IsOptional(),
    IsEnum([UserType, "PROVIDER"])
], BaseEventMetadata.prototype, "userType", void 0);
__decorate([
    IsString(),
    IsOptional()
], BaseEventMetadata.prototype, "userId", void 0);
export class EnrollmentEventMetadata extends BaseEventMetadata {
}
__decorate([
    IsOptional(),
    IsString({ each: true })
], EnrollmentEventMetadata.prototype, "targetPatients", void 0);
__decorate([
    IsOptional(),
    IsEnum(EnrollmentFlowType)
], EnrollmentEventMetadata.prototype, "flowType", void 0);
__decorate([
    IsOptional(),
    IsEnum(EnrollmentDecision)
], EnrollmentEventMetadata.prototype, "decision", void 0);
__decorate([
    IsString(),
    IsOptional()
], EnrollmentEventMetadata.prototype, "page", void 0);
export class PrereadEventMetadata extends BaseEventMetadata {
}
__decorate([
    IsOptional(),
    IsString({ each: true })
], PrereadEventMetadata.prototype, "targetPatients", void 0);
export class VideoEventMetadata extends BaseEventMetadata {
}
__decorate([
    IsOptional(),
    IsString()
], VideoEventMetadata.prototype, "videoUrl", void 0);
export class EmailCollectedEventMetadata extends BaseEventMetadata {
}
__decorate([
    IsString()
], EmailCollectedEventMetadata.prototype, "email", void 0);
export class ErrorEventMetadata extends BaseEventMetadata {
}
__decorate([
    IsString(),
    IsOptional()
], ErrorEventMetadata.prototype, "errorMessage", void 0);
__decorate([
    IsString()
], ErrorEventMetadata.prototype, "errorStackTrace", void 0);
export class EventDto {
}
__decorate([
    IsOptional(),
    IsString()
], EventDto.prototype, "organizationId", void 0);
__decorate([
    IsOptional(),
    IsString()
], EventDto.prototype, "studyId", void 0);
__decorate([
    IsOptional(),
    IsString()
], EventDto.prototype, "actorId", void 0);
__decorate([
    IsEnum(EventCategory)
], EventDto.prototype, "category", void 0);
__decorate([
    IsString(),
    IsNotEmpty()
], EventDto.prototype, "action", void 0);
__decorate([
    IsOptional(),
    IsObject()
], EventDto.prototype, "metadata", void 0);
export class HeapEventDto {
}
__decorate([
    IsString()
], HeapEventDto.prototype, "event", void 0);
__decorate([
    IsString(),
    IsOptional()
], HeapEventDto.prototype, "identity", void 0);
__decorate([
    IsOptional(),
    IsString()
], HeapEventDto.prototype, "user_id", void 0);
__decorate([
    IsOptional(),
    IsObject()
], HeapEventDto.prototype, "properties", void 0);
export class DateRangeDto {
}
__decorate([
    IsOptional(),
    IsDate(),
    Type(() => Date)
], DateRangeDto.prototype, "startDate", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date)
], DateRangeDto.prototype, "endDate", void 0);
export function mapConsentTypeToEventCategory(consentType) {
    var _a;
    const mapping = {
        [ConsentType.PATIENT_DIRECTED_DATA_EXCHANGE]: EventCategory.PATIENT_DIRECTED_DATA_EXCHANGE,
        [ConsentType.DATA_AUTHORIZATION]: EventCategory.DATA_AUTHORIZATION,
    };
    return (_a = mapping[consentType]) !== null && _a !== void 0 ? _a : EventCategory.PATIENT_DIRECTED_DATA_EXCHANGE;
}
